module.exports = __webpack_public_path__ + "media/dashboard/assets/images/priority_icons/medium-2cf3d3aff623ab4efcca60a343c5ed08.svg";